<div class="modal-material-position" data-cy="modal-material-position">
  @if (isLoading) {
    <div class="spinner-container">
      <app-loading-spinner class="center-spinner"></app-loading-spinner>
    </div>
  }
  <div class="modal-header {{modalWarningClass}}">
    @if (!selectedPosition) {
      <p class="modal-title"
      data-cy="modal-material-position-title">Add position</p>
    }
    @if (selectedPosition) {
      <p class="modal-title"
      data-cy="modal-material-position-title">Edit</p>
    }
    <button (click)="activeModal.dismiss()" class="close" type="button"></button>
  </div>

  @if (showWarningBoxDecisionCode) {
    <div class="warning-box-wrapper">
      <app-warning-box [warningLevel]="warningBoxLevel">
        @if (warningBoxLevel === WarningsEnum.ERROR) {
          <span class="warning-box-message"
            data-cy="material-position-modal-warning-box-message">Decision code <strong>{{modalValues.decision.code}}</strong> with claim code <strong>{{this.claimCodeCode}}</strong>
            was not found in the selected supplying packing plant <strong>{{this.supplyingPackingPlantCode}}</strong>.<br/>
            <strong>Please check your entries.</strong></span>
          }
        </app-warning-box>
      </div>
    }

    @if (showWarningBoxHU) {
      <div class="warning-box-wrapper">
        <app-warning-box [warningLevel]="warningBoxLevel">
          @if (warningBoxLevel === WarningsEnum.ERROR) {
            <ng-container class="warning-box-message">
              <div data-cy="material-position-modal-warning-box-message" [innerHTML]="errorMessage"></div>
            </ng-container>
          } @else {
            <span class="warning-box-message"
            data-cy="material-position-modal-warning-box-message">HU validation is unavailable at the moment.</span>
          }
        </app-warning-box>
      </div>
    }


    <div class="modal-body">
      <p class="modal-material-position-material-number"
      data-cy="modal-material-position-material-number">{{material | prettyPrintMaterialNumber | undefinedValue}}</p>

      <div class="grid-container">
        <div class="grid-item">
          <app-input-units #quantityInput
            (inputStateChange)="manageQuantityStatusChange($event)"
            (inputValueChange)="setQuantityValue($event)"
            [maxLength]="6"
            [messages]="quantityMessages"
            [validators]="validators.quantity"
            [warningLevel]="WarningsEnum.INFO"
            baseCypressTag="modal-material-position-quantity"
            label="Quantity"
            placeholder="0"
          units="{{material.salesUnit | undefinedValue}}"></app-input-units>
        </div>

        <div class="grid-item">
          <app-input-dropdown #decisionCodeInput
            (inputStateChange)="manageDecisionCodeStatusChange($event)"
            (inputValueChange)="setDecisionCodeValue($event)"
            [inputFormatter]="typeahead.inputTextCodeNameFormatter"
            [messages]="decisionCodeMessages"
            [resultFormatter]="typeahead.inputTextCodeNameFormatter"
            [resultsFunction]="searchDecisionCodes"
            [validators]="validators.decision"
            [warningLevel]="WarningsEnum.INFO"
            baseCypressTag="modal-material-position-decision-code"
            label="Decision code"
          placeholder="Search or select decision code"></app-input-dropdown>
        </div>

        <div class="grid-item full-line">
          <app-input-dropdown #errorCodeInput
            (inputStateChange)="manageErrorCodeStatusChange($event)"
            (inputValueChange)="setErrorCodeValue($event)"
            [inputFormatter]="typeahead.inputTextCodeNameFormatter"
            [messages]="errorCodeMessages"
            [resultFormatter]="typeahead.inputTextCodeNameFormatter"
            [resultsFunction]="searchErrorCodes"
            [validators]="validators.claimError"
            [warningLevel]="WarningsEnum.INFO"
            baseCypressTag="modal-material-position-error-code"
            label="Error code"
          placeholder="Search or select error code"></app-input-dropdown>
        </div>

        <div class="grid-item">
          <app-input-text #handlingUnitInput
            (inputBlur)="validateHandlingUnit()"
            (inputStateChange)="manageHandlingUnitStatusChange($event)"
            (inputValueChange)="setHandlingUnitValue($event)"
            [maxLength]="14"
            [messages]="handlingUnitMessages"
            [validators]="validators.handlingUnit"
            [warningLevel]="WarningsEnum.INFO"
            baseCypressTag="modal-material-position-handling-unit"
            label="Handling Unit"
          placeholder="e.g. 00000000000000"></app-input-text>
        </div>

        <div class="grid-item small-input">
          <app-input-text #timeEffortInput
            (inputStateChange)="manageTimeEffortStatusChange($event)"
            (inputValueChange)="setTimeEffortValue($event)"
            [maxLength]="5"
            [messages]="timeEffortMinutesMessages"
            [validators]="validators.timeEffort"
            [warningLevel]="timeEffortRequired"
            baseCypressTag="modal-material-position-time-effort"
            label="TE minutes"
          placeholder="e.g. 1"></app-input-text>
        </div>

        <div class="grid-item full-line">
          <label>BI category
            <app-warning-star [type]="WarningsEnum.INFO"></app-warning-star>
          </label>
          <app-toggle-button
            (selectedOption)="setBusinessCategoryValue($event)"
            [options]="toggleOptions"
            [preSelectedOption]="toggleButtonSelectedOption"
          [resetSelection]="resetBusinessCategory"></app-toggle-button>
        </div>
      </div>
    </div>

    @if (!selectedPosition) {
      <div class="modal-footer">
        <button (click)="activeModal.close()"
          class="btn-text-link discardButton"
          data-cy="modal-material-position-button-discard"
          type="button">
          <span class="text">Discard</span>
        </button>
        <button (click)="addAndNew()"
          [disabled]="!isValidForAddAndNew()"
          class="btn-secondary addAndNewButton"
          data-cy="modal-material-position-button-add-and-new"
          type="button">
          <span>Add and New</span>
        </button>
        <button (click)="add()"
          [disabled]="!isValidForAdd()"
          class="btn-primary addButton"
          data-cy="modal-material-position-button-add"
          type="button">
          <span>Add</span>
        </button>
      </div>
    }

    @if (selectedPosition) {
      <div class="modal-footer">
        <button (click)="activeModal.close()"
          class="btn-text-link discardButton"
          data-cy="modal-material-position-button-discard"
          type="button">
          <span class="text">Discard</span>
        </button>
        <button (click)="add()"
          [disabled]="!isValidForEdit()"
          class="btn-primary addButton"
          data-cy="modal-material-position-button-add"
          type="button">
          <span>Edit</span>
        </button>
      </div>
    }
  </div>
